import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Timestamps come back from the API in UTC (trailing 'Z'). Interpret them as UTC
 * and render in the VIEWER'S LOCAL time zone, US format, 12-hour clock.
 * e.g. 2026-08-15T19:22:00Z -> "Aug 15, 2026, 03:22 PM" for a UTC-4 viewer.
 * `dayjs.utc(value).local()` treats the value as UTC even if the trailing 'Z'
 * is ever missing, then converts to local.
 */
export const formatDateTime = (value) => {
  if (!value) return '-';
  const d = dayjs.utc(value).local();
  return d.isValid() ? d.format('MMM DD, YYYY, hh:mm A') : '-';
};

/**
 * Date-only display (US format). DateOnly values (e.g. "2026-08-14") carry no
 * time zone, so they are formatted as-is with no UTC/local conversion (which
 * would otherwise shift the calendar date). Send DateOnly back via toApiDate.
 */
export const formatDate = (value) => {
  if (!value) return '-';
  const d = dayjs(value);
  return d.isValid() ? d.format('MMM DD, YYYY') : '-';
};

/** Convert a dayjs/Date/string into the YYYY-MM-DD the API expects for DateOnly. */
export const toApiDate = (value) => (value ? dayjs(value).format('YYYY-MM-DD') : null);

export const money = (value, currency = 'USD') => {
  if (value === null || value === undefined) return '-';
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
  } catch {
    return `${currency} ${value}`;
  }
};
